import getColour from '@lendi-ui/commons/colours';
import Dollar from '@lendi-ui/icon/Dollar';

import { Prefix } from '../_common/style';
import NumericalInputField, { NumericalInputFieldProps } from '.';

const DollarInputField = (props: NumericalInputFieldProps) => (
  <NumericalInputField
    {...props}
    before={
      <Prefix>
        <Dollar color={getColour('text', 'subtle')} />
      </Prefix>
    }
    isDecimalValid={true}
  />
);

export default DollarInputField;
